import dayjs from 'dayjs';

export class TransportIncident {
  public id?: number;
  public cause?: string;
  public comment?: string;
  public date?: dayjs.Dayjs;
  public incidentAmount?: number;
  public originTransportOrder?: number;
  public creatorLogin?: string;
  public hasGazoleTax?: boolean;
  public gazoleTaxAmount?: number;
  public gazoleTaxRate?: number;

  constructor(data: any = {}) {
    this.date = data.date ? dayjs(data.date) : undefined;
    Object.assign(this, data);
  }
}
